import type {
    SiteNavigationPrimary,
    SiteNavigationPrimaryField,
    SiteNavigationPrimaryLevel,
    SiteNavigationPrimarySublevel,
} from '../navigation/site-navigation-types';

function filterSiteNavSublevelItems(
    raw: SiteNavigationPrimaryLevel['items'],
): NonNullable<SiteNavigationPrimaryLevel['items']> {
    return (raw ?? []).filter((leaf: SiteNavigationPrimarySublevel | null | undefined): leaf is SiteNavigationPrimarySublevel => {
        if (!leaf?.title) return false;
        return !!leaf.link;
    });
}

export function filterSiteNavigationPrimaryRootList(
    roots:
    | ReadonlyArray<SiteNavigationPrimary | null | undefined>
    | null
    | undefined,
): SiteNavigationPrimary[] {
    if (!roots?.length) {
        return [];
    }

    return [...roots]
        .filter((root): root is SiteNavigationPrimary => Boolean(root?.title))
        .map((root) => {
            const rows = (root.items ?? [])
                .filter((row: SiteNavigationPrimaryLevel | null | undefined): row is SiteNavigationPrimaryLevel => Boolean(row?.title))
                .map((row: SiteNavigationPrimaryLevel) => {
                    const items = filterSiteNavSublevelItems(row.items);
                    const hasRowHref = !!row.link;
                    const hasLeaves = items.length > 0;
                    if (!hasRowHref && !hasLeaves) return null;
                    return { ...row, items };
                })
                .filter((row): row is SiteNavigationPrimaryLevel & { items: NonNullable<SiteNavigationPrimaryLevel['items']> } => row !== null);

            return { ...root, items: rows };
        })
        .filter((root) => {
            const hasHref = !!root.link;
            const hasRows = (root.items?.length ?? 0) > 0;
            return hasHref || hasRows;
        });
}

export function filterSiteNavigationPrimaryFromField(
    primary: SiteNavigationPrimaryField | null | undefined,
): SiteNavigationPrimary[] {
    return filterSiteNavigationPrimaryRootList(primary ?? []);
}
